import { vnTemplate } from '../../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate';
import { listPageSelect_template } from '~/components/templates/listPageSelect_template';
import { html, LpButton, LpEditCard, LpEditGrid, LpEditPage, LpEditSectionTitle, LpFormField, LpIcon, LpPageHeader, raw } from '~/design-system';
import { getEntityActiveStatusOption } from '~/utils/entityActiveStatus';
export class adminCreativeEdit_template extends vnTemplate {
    getTemplateName() {
        return 'adminCreativeEdit-template';
    }
    getMainElementClasses() {
        return ['w-content'];
    }
    buildViewModel() {
        const self = this;
        return {
            id: ko.observable(null),
            partnerId: ko.observable(''),
            partnerTitle: ko.observable(''),
            descShort: ko.observable(''),
            descLong: ko.observable(''),
            status: ko.observable('1'),
            hasSmallIcon: ko.observable(false),
            hasLargeIcon: ko.observable(false),
            smallIconUrl: ko.observable(''),
            largeIconUrl: ko.observable(''),
            duplicateImageSmall: ko.observable(''),
            duplicateImageLarge: ko.observable(''),
            onClickSave: function () { self.caller.saveCreative(); },
            onClickDelete: function () { self.caller.deleteCreative(); },
            onClickBack: function () { self.caller.backToCreatives(); },
            onSmallIconChange: function (data, event) { self.caller.uploadCreativeIcon('small', event); },
            onLargeIconChange: function (data, event) { self.caller.uploadCreativeIcon('large', event); },
        };
    }
    initPartial() {
        const vm = this.getTemplateViewModel();
        this.statusSelect = new listPageSelect_template('adminCreativeStatusSelect', vm, this.caller);
        this.statusSelect.setLabel('Status');
        this.statusSelect.setFormField(true);
        this.statusSelect.setOptions([
            getEntityActiveStatusOption({ id: '1', name: 'Active' }),
            getEntityActiveStatusOption({ id: '0', name: 'Inactive' }),
            getEntityActiveStatusOption({ id: '2', name: 'Archived' }),
        ]);
        this.statusSelect.bindValue(vm.status);
    }
    getTemplateHtml() {
        return `
            ${LpPageHeader({
            title: html `<span data-bind="text: id() ? 'Edit Creative' : 'New Creative'"></span>`,
            description: 'Define the partner copy and status used by the recruiting offer flow.',
            icon: 'image',
            actions: html `
                    ${LpButton({
                label: 'Back',
                prefixIcon: 'arrow-left',
                size: 'base',
                variant: 'secondary',
                attributes: {
                    'data-bind': 'click: onClickBack',
                },
            })}
                    ${LpButton({
                label: 'Archive',
                prefixIcon: 'archive',
                size: 'base',
                variant: 'secondary',
                attributes: {
                    'data-bind': 'visible: id, click: onClickDelete',
                },
            })}
                    ${LpButton({
                label: 'Save',
                prefixIcon: 'check',
                size: 'base',
                variant: 'primary',
                attributes: {
                    'data-bind': 'click: onClickSave',
                },
            })}
                `,
        })}

            ${LpEditPage({
            className: 'edit-page--creative',
            children: html `
                    ${LpEditCard({
                title: 'Creative Summary',
                description: 'Define the partner copy and status used by the recruiting offer flow.',
                className: 'edit-card--creative-summary',
                children: LpEditGrid({
                    children: html `
                                ${LpEditSectionTitle({ title: 'Basic Information' })}
                                ${LpFormField({
                        label: 'Partner ID',
                        children: raw('<input class="edit-input" type="number" placeholder="e.g. 1024" data-bind="value: partnerId" />'),
                    })}
                                ${LpFormField({
                        label: 'Status',
                        children: raw(this.statusSelect.getHtmlBuild()),
                    })}
                                ${LpFormField({
                        label: 'Title',
                        className: 'edit-span',
                        children: raw('<input class="edit-input" type="text" placeholder="Creative title shown to leads" data-bind="value: partnerTitle" />'),
                    })}
                                ${LpEditSectionTitle({ title: 'Content' })}
                                ${LpFormField({
                        label: 'Short Description',
                        className: 'edit-span',
                        children: raw('<textarea class="edit-input edit-textarea edit-textarea--short" rows="3" placeholder="Short summary (up to 3 lines)" data-bind="value: descShort"></textarea>'),
                    })}
                                ${LpFormField({
                        label: 'Long Description',
                        className: 'edit-span',
                        children: raw('<textarea class="edit-input edit-textarea" rows="8" placeholder="Full description shown on the offer" data-bind="value: descLong"></textarea>'),
                    })}
                            `,
                }),
            })}

                    ${LpEditCard({
                className: 'edit-card--images',
                header: raw(this.renderCreativeMediaHeader()),
                children: raw(this.renderCreativeMedia()),
            })}
                `,
        })}
        `;
    }
    renderCreativeMediaHeader() {
        return `
            <div>
                <h2>Media</h2>
                <p data-bind="visible: id">Upload a new file to replace either creative image.</p>
                <p data-bind="visible: !id()">Save the creative before uploading images.</p>
            </div>
        `;
    }
    renderCreativeMedia() {
        return `
            <div class="edit-grid creative-edit-image-grid" data-bind="visible: id">
                ${this.renderCreativeImageSlot({
            label: 'Small Icon',
            urlBinding: 'smallIconUrl',
            changeBinding: 'onSmallIconChange',
            description: 'Used in list cards and thumbnails.',
            alt: 'Small creative icon',
        })}
                ${this.renderCreativeImageSlot({
            label: 'Large Icon',
            urlBinding: 'largeIconUrl',
            changeBinding: 'onLargeIconChange',
            description: 'Used as the hero image on the offer page.',
            alt: 'Large creative icon',
            modifierClass: 'creative-edit-upload--large',
        })}
            </div>

            <div class="creative-edit-empty-state" data-bind="visible: !id()">
                <strong>Images unlock after save.</strong>
                <span>Create the creative first, then upload small and large images from the edit page.</span>
            </div>
        `;
    }
    renderCreativeImageSlot({ label, urlBinding, changeBinding, description, alt, modifierClass = '', }) {
        const uploadClassName = ['creative-edit-upload', modifierClass].filter(Boolean).join(' ');
        return `
            <div class="form-group creative-edit-slot">
                <span class="form-label">${label}</span>
                <div class="${uploadClassName}" data-bind="css: { 'has-image': !!${urlBinding}() }">
                    <div class="creative-edit-upload__media">
                        <img data-bind="visible: ${urlBinding}, attr: { src: ${urlBinding} }" alt="${alt}" />
                        <div class="creative-edit-upload__placeholder" data-bind="visible: !${urlBinding}()" aria-hidden="true">
                            ${LpIcon({ name: 'upload-simple', size: 24 })}
                        </div>
                    </div>
                    <div class="creative-edit-upload__body">
                        <p class="creative-edit-upload__desc">${description}</p>
                        <label class="button creative-edit-upload__button" data-color="secondary" data-size="sm">
                            <input class="creative-edit-upload__input" type="file" accept="image/*" data-bind="event: { change: ${changeBinding} }" />
                            <span class="button__content">
                                ${LpIcon({ name: 'upload-simple', size: 16 })}
                                <span data-bind="text: ${urlBinding}() ? 'Replace image' : 'Choose file'"></span>
                            </span>
                        </label>
                    </div>
                </div>
            </div>
        `;
    }
    setCreative(creative, duplicate = false) {
        const vm = this.getTemplateViewModel();
        vm.id(!duplicate && creative && creative.id ? Number(creative.id) : null);
        vm.partnerId(creative && creative.partnerId ? String(creative.partnerId) : '');
        vm.partnerTitle(creative && creative.partnerTitle ? creative.partnerTitle : '');
        vm.descShort(creative && creative.descShort ? creative.descShort : '');
        vm.descLong(creative && creative.descLong ? creative.descLong : '');
        vm.status(creative && typeof creative.status !== 'undefined' && creative.status !== null ? String(creative.status) : '1');
        vm.hasSmallIcon(Boolean(creative && creative.hasSmallIcon));
        vm.hasLargeIcon(Boolean(creative && creative.hasLargeIcon));
        vm.smallIconUrl(this.resolveImageUrl(creative, 'small'));
        vm.largeIconUrl(this.resolveImageUrl(creative, 'large'));
        vm.duplicateImageSmall(duplicate && creative && creative.imageSmall ? creative.imageSmall : '');
        vm.duplicateImageLarge(duplicate && creative && creative.imageLarge ? creative.imageLarge : '');
    }
    getPayload() {
        const vm = this.getTemplateViewModel();
        const payload = {
            id: vm.id(),
            partnerId: vm.partnerId() ? Number(vm.partnerId()) : null,
            partnerTitle: vm.partnerTitle(),
            descShort: vm.descShort(),
            descLong: vm.descLong(),
            status: Number(vm.status()),
        };
        if (vm.duplicateImageSmall()) {
            payload.imageSmall = vm.duplicateImageSmall();
        }
        if (vm.duplicateImageLarge()) {
            payload.imageLarge = vm.duplicateImageLarge();
        }
        return payload;
    }
    resolveImageUrl(creative, size) {
        if (!creative || !creative.id) {
            return '';
        }
        if (size === 'small' && !creative.hasSmallIcon && !creative.imageSmall) {
            return '';
        }
        if (size === 'large' && !creative.hasLargeIcon && !creative.imageLarge) {
            return '';
        }
        const inlineImage = size === 'small' ? creative.imageSmall : creative.imageLarge;
        if (inlineImage) {
            return 'data:image/png;base64,' + inlineImage;
        }
        return '/api/admin/rest/api/lead/offer/' + creative.id + '/icon/' + size + '?cache=' + Date.now();
    }
}
